<template>
  <page :basic="true">
    <span slot="header">Components</span>
    <template slot="breadcrumbs">
      <b-breadcrumb :items="breadcrumbs"/>
      <template v-if="role === 'owner' || role === 'master' || role ==='admin'">
        <div>
          <router-link :to="{name: 'admin-components'}">
            <i class="fas fa-exchange-alt"></i> Switch to Admin View
          </router-link>
        </div>
      </template>
      <template v-if="role !== 'owner'">
        <div>
          <router-link :to="{name: 'starred-topics'}">
            <i class="fas fa-star"></i> Your Starred Topics
          </router-link>
        </div>
      </template>
    </template>
    <components-table :view="view"/>
  </page>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import componentsTable from './table'
import page from '../../../templates/page'

export default {
  components: {
    componentsTable,
    page
  },
  data () {
    return {
      breadcrumbs: [{
        text: 'Modules',
        to: { name: 'client-modules' }
      },
      {
        text: 'Components',
        active: true
      }]
    }
  },
  computed: {
    ...mapState('components', {
      view: '_clientView'
    }),
    ...mapGetters('client', {
      role: 'getCurrentRole'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/client/components/index.vue